import React, { memo, useState } from "react";
import moment from "moment";
import http from "../utils/api";
import Velocimetro from "../components/Chart/Velocimetro";
import localforage from "../utils/localforage";
import Grid from "@material-ui/core/Grid";
import useSWR from "swr";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flex: 1,
    flexGrow: 1,
    position: "relative",
    // height: '100%',
    maxWidth: "100vw",
    [theme.breakpoints.up("sm")]: {
      height: "100%",
    },
  },
}));

const initialState = {
  data: {},
  horasLiberadas: {},
  projecao: {},
};

function ResumoHorasMes() {
  const classes = useStyles();
  const { data: state = initialState } = useSWR("/saldo-horas", fetchSaldo);
  const [codigoColaborador, setCodigoColaborador] = useState("");

  async function fetchSaldo() {
    const periodo = {
      inicio: moment().date(21).subtract(1, "months"),
      fim: moment().date(20),
    };
    if (moment().date() >= 21) {
      periodo.inicio.add(1, "months");
      periodo.fim.add(1, "months");
    }
    const response = initialState;

    return http
      .get(`apontamentos/saldo-horas?data=${moment().format("YYYY-MM-DD")}`)
      .then(async ({ data }) => {
        response.data = await data.data;
        await localforage.setItem("saldo-horas", data.data);
        response.horasLiberadas = await http
          .get(`horas-liberadas`, {
            params: {
              inicio: periodo.inicio.format("YYYY-MM-DD"),
              fim: periodo.fim.format("YYYY-MM-DD"),
            },
          })
          .then(async ({ data }) => {
            const res = data?.data?.[0] ?? {};
            await localforage.setItem("horas-liberadas", data.data);
            return res;
          });
        response.projecao = await http
          .get(`projecao-horas`)
          .then(({ data }) => {
            return data?.data ?? {};
          });
        setCodigoColaborador(response.data?.codigoColaborador);
        return response;
      });
  }

  return (
    <Grid className={classes.container}>
      <Grid
        container
        direction={"row"}
        justifyContent={"center"}
        alignContent={"center"}
        alignItems={"center"}
        className={classes.container}
      >
        <Velocimetro options={state} key={codigoColaborador} />
      </Grid>
    </Grid>
  );
}

export default memo(ResumoHorasMes);
